import { useEffect, useState } from 'react'
import classnames from 'classnames'
import { tr } from 'react-hook-form-auto'
import { Icon } from '../ui/bootstrap/bootstrap'

import styles from './AmountRangeField.sass'

// Controlled field whose value holds { amount, amountMax }. Ranges
// are rare, so the max input hides behind a button. Legacy values
// arrive as plain numbers.
export const AmountRangeField = ({
  value,
  onChange,
  name,
  defaultValue,
  styles: formStyles
}) => {
  // The doc can show up renders after mount (CrudView), when the
  // form hook already froze its defaults: adopt it as it arrives
  useEffect(() => {
    if (value === undefined && defaultValue !== undefined)
      onChange(defaultValue)
  }, [value, defaultValue])

  const useValue = value === undefined ? defaultValue : value
  const range = useValue && typeof useValue == 'object'
    ? useValue
    : { amount: useValue, amountMax: null }

  const hasMax = range.amountMax != null && range.amountMax !== ''
  const [userExpanded, setUserExpanded] = useState(false)
  const expanded = hasMax || userExpanded

  const inputClasses = classnames(
    formStyles.input,
    formStyles.standard,
    styles.amount
  )

  const setPart = (part, raw) => {
    onChange({
      ...range,
      [part]: raw === '' ? null : raw
    })
  }

  const toggle = e => {
    e.preventDefault()

    if (expanded)
      onChange({ ...range, amountMax: null })

    setUserExpanded(!expanded)
  }

  return (
    <span className={styles.wrap}>
      <input
        type="number"
        inputMode="decimal"
        step="any"
        min="0"
        name={name}
        value={range.amount ?? ''}
        onChange={e => setPart('amount', e.target.value)}
        className={inputClasses}
      />
      {expanded &&
        <>
          <span className={styles.separator}>–</span>
          <input
            type="number"
            inputMode="decimal"
            step="any"
            min="0"
            value={range.amountMax ?? ''}
            onChange={e => setPart('amountMax', e.target.value)}
            className={inputClasses}
            aria-label={tr('shop.amountRange.max')}
          />
        </>}
      <button
        type="button"
        className={styles.toggle}
        onClick={toggle}
        title={expanded
          ? tr('shop.amountRange.noMax')
          : tr('shop.amountRange.addMax')}
      >
        <Icon icon={expanded ? 'times' : 'arrows-left-right-to-line'} />
      </button>
    </span>
  )
}
